module.exports = __webpack_public_path__ + "static/media/afferolab_logo_white.8c626db4.svg";